export default __webpack_public_path__ + "static/media/160_2V.8be0bb7d.pdf";